<template>
	<div class="s-graphs">
		<h2 class="ln-u-visuallyhidden">{{ i18n.graphs[locale] }}</h2>
		<div class="s-graphs__wrapper">
			<div
				class="s-graphs__graph mdc-card ln-teaser"
				v-bind:class="{ 's-graphs__graph--disabled': graph.disabled }"
				v-for="(graph, index) in graphs"
				v-bind:key="index"
			>
				<div
					class="ln-teaser__header s-graphs__header"
					v-bind:style="{ background: getColor(graph) }"
				>
					<div class="ln-teaser__header-title">
						<h3 class="mdc-typography--headline3 ln-teaser__title">
							{{ graph.title[locale] }}
						</h3>
					</div>
				</div>
				<div class="ln-teaser__content mdc-typography--body2 s-graphs__content">
					<div v-html="getIcon(graph)" class="s-graphs__icon" />
					<div class="s-graphs__chart">
						<svg viewBox="0 0 36 36">
							<path
								class="s-graphs__circle s-graphs__circle--background"
								stroke-dasharray="100, 100"
								d="M18 2.0845
		a 15.9155 15.9155 0 0 1 0 31.831
		a 15.9155 15.9155 0 0 1 0 -31.831"
							/>
							<path
								class="s-graphs__circle"
								v-bind:stroke="getColor(graph)"
								v-bind:stroke-dasharray="`${graph.value}, 100`"
								d="M18 2.0845
		a 15.9155 15.9155 0 0 1 0 31.831
		a 15.9155 15.9155 0 0 1 0 -31.831"
							/>
						</svg>
						<span class="s-graphs__chart-text">{{ getLabel(graph, locale) }}</span>
					</div>
				</div>
				<div
					class="mdc-card__actions ln-teaser__actions mdc-typography--body2 s-graphs__actions"
					v-if="graph.details"
				>
					{{ graph.details[locale] }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import graphHelpers from '../helpers/graphs';

export default {
	name: 'Graphs',
	methods: {
		...graphHelpers
	},
	props: {
		graphs: Array,
		i18n: Object,
		locale: {
			type: String,
			default: 'de'
		}
	}
};
</script>

<style lang="scss">
.s-app .s-graphs {
	@import '@legacynotes/frontend/src/assets/css/variables-new';
	@import '@legacynotes/frontend/src/assets/css/mixins-new';
	@import '@legacynotes/frontend/src/components/teaser/teaser';

	margin-top: 3em;

	&__wrapper {
		display: flex;
		margin-left: -0.75rem;
		margin-right: -0.75rem;

		@include ln-mq-mobile {
			display: block;
		}

		@media print {
			display: flex;
		}
	}

	&__graph {
		flex: 1;
		margin-left: 0.75rem;
		margin-right: 0.75rem;

		&.ln-teaser {
			background: rgb(243, 243, 243);
		}

		&--disabled {
			opacity: 0.35;
		}

		@include ln-mq-mobile {
			&:not(:first-child) {
				margin-top: 1.5rem;
			}
		}

		@media print {
			&:not(:first-child) {
				margin-top: 0;
			}
		}
	}

	&__header {
		color: $mdc-theme-on-secondary;

		&.ln-teaser__header {
			min-height: 0;
		}

		.ln-teaser__title {
			color: inherit;
		}

		@media print {
			color: inherit;
		}
	}

	&__content {
		display: flex;
		justify-content: space-between;
	}

	&__icon,
	&__chart {
		height: 6rem;

		svg {
			height: 100%;
		}

		@media print {
			height: 4rem;
		}
	}

	&__icon {
		margin-right: 1rem;
		width: 7.5rem;
	}

	&__chart {
		width: 6rem;
		flex-shrink: 0;
		position: relative;

		&-text {
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 100%;
			font-size: 1.3rem;
			text-align: center;
		}
	}

	&__circle {
		fill: none;
		stroke-width: 3.5;
		stroke-linecap: round;
		animation: s-circle-progress 1s ease-out;
		transition: stroke-dasharray 0.3s ease-out;

		&--background {
			stroke: #d8d8d8;
		}
	}

	&__actions {
		&.ln-teaser__actions {
			padding-left: 1rem;
			padding-right: 1rem;
		}
	}
}

@keyframes s-circle-progress {
	0% {
		stroke-dasharray: 0 100;
	}
}
</style>
